module.exports = __webpack_public_path__ + "down_arrow.a8b40dee4642b35a4be5cfe1abc10845.svg";